import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { useNavigation } from '~/Hooks';
import { requestClearError, selectErrors } from '~/store/app';

export const useEventPageErrors = () => {
  const dispatch = useDispatch();
  const { goBack } = useNavigation();
  const singleEventErrors = useSelector(selectErrors(REQUEST_ACTIONS.SINGLE_EVENT));
  const cleanErrorMessages = bindActionCreators(requestClearError, dispatch);

  useEffect(() => {
    if (singleEventErrors) {
      cleanErrorMessages(REQUEST_ACTIONS.SINGLE_EVENT);
      goBack();
    }
  }, [singleEventErrors]);

  return {
    singleEventErrors,
    goBack,
  };
};
